document.addEventListener("DOMContentLoaded", () => {
    var variantSelect = document.querySelector('#productSelect')

    if (!variantSelect)
        return false;

    selectedVariant = null

    var spin = '<div class="flex justify-center""><svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg></div>'

    for (var i = 0; i < variantSelect.length; i++) {
        if (!variantSelect[i].value.includes('sold out')) {
            selectedVariant = variantSelect[i]
            break
        }
    }

    
    var buy_now_btn = document.querySelector('#buy_now')
    var add_to_cart_btn = document.querySelector('#AddToCart')
    var add_to_cart_form = document.querySelector('#AddToCartForm')

    if (!buy_now_btn)
        return false

    var itemQuantity = document.querySelector('#qty')
    var max_variant_qty = document.querySelector('.qty-count')
    
    var price = document.querySelector('.price')
    var price_compare = document.querySelector('.price-compare')

    var overlay = document.querySelector('.overlay')

    if (selectedVariant === null) {
        buy_now_btn.classList.add('pointer-events-none', 'opacity-50')
        add_to_cart_btn.classList.add('pointer-events-none', 'opacity-50')
        buy_now_btn.innerText = 'Non disponible'
        add_to_cart_btn.innerText = 'Non disponible'
        return 
    }

    buy_now_btn.addEventListener('click', (e) => {
        e.target.innerHTML = spin
        e.target.classList.add('pointer-events-none', 'opacity-50')
    })

    price.innerText = selectedVariant.getAttribute('data-price')
    
    if (selectedVariant !== null)
        buy_now_btn.setAttribute('href', '/cart/' + selectedVariant.value + ':' + itemQuantity.value)
    else
        buy_now_btn.setAttribute('disabled', 'disabled')


    variantSelect.addEventListener('change', (event) => {
        selectedVariant = event.target
        itemQuantity.value = 1
        max_variant_qty.innerText = event.target[event.target.options.selectedIndex].getAttribute('data-qty') 
        buy_now_btn.setAttribute('href', '/cart/' + selectedVariant.value + ':' + itemQuantity.value)
        price.innerText = event.target[event.target.options.selectedIndex].getAttribute('data-price')
        var price_compare_attr = event.target[event.target.options.selectedIndex].getAttribute('data-price-compare')
        if (price_compare_attr) {
            price_compare.classList.remove('hidden')
            price_compare.innerText = price_compare_attr
        }
        else
            price_compare.classList.add('hidden')
    })

    itemQuantity.addEventListener('change', () => {
        if (max_variant_qty && itemQuantity) {
            if (parseInt(max_variant_qty.innerText) < parseInt(itemQuantity.value))
               itemQuantity.value = parseInt(max_variant_qty.innerText)
            else if(parseInt(itemQuantity.value) < 1)
                itemQuantity.value = 1
            buy_now_btn.setAttribute('href', '/cart/' + selectedVariant.value + ':' + itemQuantity.value)
        }
    })

    add_to_cart_btn.addEventListener('click', (e) => {
        e.preventDefault()
        var formData = {
            'items': [{
                'id': selectedVariant.value,
                'quantity': itemQuantity.value
            }]
        }
        e.target.innerHTML = spin
        e.target.classList.add('pointer-events-none', 'opacity-50', 'bg-orange')
        let result = fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            let res = response.json()
            res.then(data => {
                console.log(data.items[0].image)
                overlay.querySelector('.product-img img').setAttribute('src', data.items[0].image)
            })
            if (response.ok) {
                overlay.classList.toggle("hidden")
                var productTitle = document.querySelector('h2.product-title').innerText
                overlay.querySelector('.product-name-overlay').innerText = `${itemQuantity.value}x ${productTitle}`
                e.target.innerHTML = "Ajouter au panier"
                e.target.classList.remove('pointer-events-none', 'opacity-50', 'bg-orange')
                refreshCart()
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        })

    })
});

function refreshCart() {
    //console.log("Cart should be updated!")
}